export default __webpack_public_path__ + "static/media/4mm 3.10ce839d.jpg";